var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313.06 95.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.34,492.11h25.48l20,22.78-20,22.67H850.34l20-22.67Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.08 0 5 94.68 24.66 94.68 46.73 0 27.08 0",
    style: {
      fill: "#5928dc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M845.34,492.11h25.48l20,22.78-20,22.67H845.34l20-22.67Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.08 0 0 94.68 19.66 94.68 41.73 0 22.08 0",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.4,554.82a7.29,7.29,0,0,1,3.67,6.3,8.27,8.27,0,0,1-.26,2.1,11.28,11.28,0,0,1-3.92,6.13,18.72,18.72,0,0,1-8.42,3.82l7.26,13.62h-12.4l-6.36-13h-2.64l-3,13h-11l8-34.4h18.45Q870.74,552.39,874.4,554.82Zm-7.71,7.72a2.74,2.74,0,0,0-1.31-2.43,7.21,7.21,0,0,0-3.89-.86h-6.81l-2,8.63h6.82a8.83,8.83,0,0,0,4.78-1.13,5.08,5.08,0,0,0,2.28-3.18A7.75,7.75,0,0,0,866.69,562.54Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.63,585.32a15.32,15.32,0,0,1-6.72-5.09,12.58,12.58,0,0,1-2.37-7.55,17.92,17.92,0,0,1,3.4-10.75,22.35,22.35,0,0,1,9.48-7.38,34.25,34.25,0,0,1,13.78-2.64,26.76,26.76,0,0,1,10.16,1.78,15.29,15.29,0,0,1,6.74,5,12.31,12.31,0,0,1,2.38,7.47,18.25,18.25,0,0,1-3.4,10.81,22.5,22.5,0,0,1-9.51,7.45,34.37,34.37,0,0,1-13.88,2.67A25.88,25.88,0,0,1,890.63,585.32Zm19.18-7.59a12.56,12.56,0,0,0,5-4.49,11.23,11.23,0,0,0,1.77-6.1,6.64,6.64,0,0,0-2.57-5.53,11.46,11.46,0,0,0-7.2-2,16.2,16.2,0,0,0-7.49,1.66,12.7,12.7,0,0,0-5,4.44,11.08,11.08,0,0,0-1.77,6.1,6.72,6.72,0,0,0,2.57,5.56c1.72,1.36,4.14,2,7.27,2A16,16,0,0,0,909.81,577.73Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966,552.39l-5.4,23.43a13.08,13.08,0,0,1-6,8.38,21.25,21.25,0,0,1-11.5,2.94q-6.18,0-9.74-2.36a7.6,7.6,0,0,1-3.57-6.76,10.5,10.5,0,0,1,.33-2.74H941a5.86,5.86,0,0,0-.19,1.42,2.59,2.59,0,0,0,1,2.2,4.36,4.36,0,0,0,2.7.74,5.47,5.47,0,0,0,3.31-1,4.69,4.69,0,0,0,1.77-2.86L955,552.39Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.83,552.39l-8,34.4h-11l8-34.4Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.25,552.39l-1.48,6.62h-12l-6.42,27.78h-11l6.42-27.78h-12l1.54-6.62Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.76,552.39l-8,34.4h-11l8-34.4Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.06,579.93h19.41l-1.61,6.86H1042l1.48-6.37,24.16-21.17h-19.28l1.61-6.86h31.87l-1.48,6.37Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.47,559l-1.6,7.15h14.71l-1.48,6.33h-14.71l-1.8,7.69h16.64l-1.54,6.61h-27.63l8-34.4h27.63l-1.55,6.62Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logoFull.495d3b16d02a0a438687bd0f232defaf.svg";
export { ForwardRef as ReactComponent };